var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPixisLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 26,
    viewBox: "0 0 28 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.40083 7.86537L7.97872 3.43067C8.31922 2.4729 8.91996 1.64921 9.70176 1.06817C10.4836 0.487127 11.4098 0.175996 12.3583 0.175781L25.5266 0.175781C25.8967 0.177596 26.2607 0.276852 26.5873 0.464974C26.914 0.653097 27.1934 0.924429 27.4013 1.25553C27.6093 1.58663 27.7397 1.96753 27.7811 2.36534C27.8226 2.76315 27.7739 3.1659 27.6393 3.53879L26.0614 7.86537H6.40083ZM5.91519 9.23295L3.1907 16.8979H19.0573C20.2064 16.7911 21.3052 16.3399 22.2305 15.5951C23.1559 14.8504 23.8711 13.8413 24.2959 12.6813L25.5564 9.23295H5.91519ZM2.70506 18.2636L0.015625 25.828H5.79071C6.45853 25.8279 7.11068 25.6091 7.66143 25.2005C8.21217 24.7919 8.63572 24.2125 8.87637 23.5385L10.7611 18.2636H2.70506Z",
    fill: "url(#paint0_linear_471_61711)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_471_61711",
    x1: 13.9081,
    y1: -0.81055,
    x2: 13.9081,
    y2: 26.8029,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2BB3F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F64FA"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPixisLogo);
export default __webpack_public_path__ + "static/media/PixisLogo.2959381b1c54ec4e0e1def66219ba8af.svg";
export { ForwardRef as ReactComponent };